import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["FeaturesSection"] */ "/vercel/path0/src/components/features-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "/vercel/path0/src/components/hero-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IndustriesSection"] */ "/vercel/path0/src/components/industries-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PartnerLogos"] */ "/vercel/path0/src/components/partner-logos.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServicesOverview"] */ "/vercel/path0/src/components/services-overview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TechnologiesSection"] */ "/vercel/path0/src/components/technologies-section.tsx");
